import { createFileRoute } from '@tanstack/react-router'
import { QueryGuard } from '../../components/query-guard'
import { InvestorProfile } from '../../features/investor/components/investor-profile'
import { StartupEntity } from '../../features/startup/components/startup-entity'
import { useInvestorQuery, useStartupQuery } from '../../hooks/api'
import { useIsFounder } from '../../hooks/use-user-type'

export const Route = createFileRoute('/_protected/')({
  component: IndexComponent,
})

function IndexComponent() {
  const isFounder = useIsFounder()

  if (!isFounder) {
    return <InvestorHome />
  }

  return <FounderHome />
}

function FounderHome() {
  const startupQuery = useStartupQuery()

  return (
    <QueryGuard query={startupQuery} errorMessage="Failed to load startup">
      {(startup) => <StartupEntity startup={startup} permissions={{ canEdit: true }} />}
    </QueryGuard>
  )
}

function InvestorHome() {
  const investorQuery = useInvestorQuery()

  return (
    <QueryGuard query={investorQuery} errorMessage="Failed to load investor">
      {(investor) => <InvestorProfile investor={investor} permissions={{ canEdit: true }} />}
    </QueryGuard>
  )
}
